export default __webpack_public_path__ + "../staticImages/favicon-32x32.png";